import { onBankAccountActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { BankAccountActivityCard } from "./BankAccountActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  bankaccountId: number
  config: server.dto.ActivityPanelConfig
}

export const BankAccountActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.BankAccountActivity>
    activityKey="bankAccount"
    itemId={props.bankaccountId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.BankAccount.ListActivity({ itemId: props.bankaccountId, page, perPage })}
    renderActivity={(activity => <BankAccountActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onBankAccountActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
